
import { ref, computed } from "@vue/composition-api";

export function section_Shared(context) {

  let store = context.root.$store;    // do destructuring

  const selectedProject = computed(() => store.getters.selectedProject);

  const getWorkitemName = (wiid) => {
    let arr = store.getters.selectedProjectWorkItems;
    let match = arr.find(item => item.wiid == wiid);
    if (match) return match.name;
    return "-- not found --";
  };

  class objDialogData {
    item = null;
    inNewMode = false;
    update = null;
    delete = null;    // remove this - confusion (project and client using this i think)
    remove = null;
    close = null;
  }

  const createDialogInfoObject = () => {
    return new objDialogData();
  };

  const getOrderedProjectItems = (context) => {
    let arr = Object.values(selectedProject.value[context]);
    arr.sort((a, b) => (a.date > b.date) ? 1 : -1);
    return arr;
  };

  return {
    getWorkitemName,
    selectedProject,
    createDialogInfoObject,
    getOrderedProjectItems: getOrderedProjectItems
  };

};
